import { NumberFormatOptions, useFormatter, useTranslations } from 'next-intl';

import { RatingGroup } from '@silvertours/common-landingpages-view';
import { UiLegacy } from '@silvertours/front-legacy-shared';

import { RatingGroupItemCriterion, RatingGroupList } from './Reviews.styles';

const ratingFormatOptions: NumberFormatOptions = {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
};

const useRatingGroupTitle = (organizers: string, hostName: string) => {
  const t = useTranslations(
    'features.trustLegacy.feedback.reviewItem.ratingGroupTitle',
  );

  return (groupName: string) => {
    switch (groupName) {
      case 'site':
        return t('site', {
          host: hostName,
        });
      case 'organizers':
        return t('organizers', {
          organizers,
        });
      default:
        return t('rentalCompanies');
    }
  };
};

type RatingGroupsProps = {
  ratingGroups: Array<RatingGroup>;
  providerQuote: any;
  host: string;
};

const RatingGroups = ({
  ratingGroups,
  providerQuote,
  host,
}: RatingGroupsProps) => {
  const format = useFormatter();
  const t = useTranslations('features.trustLegacy.feedback.reviewItem');
  const getGroupTitle = useRatingGroupTitle(providerQuote.organizers, host);

  return (
    <RatingGroupList>
      {ratingGroups.map(({ type: groupType, items }) => (
        <li key={groupType}>
          <b>{getGroupTitle(groupType)}</b>
          {items.map(({ rating, type: ratingType }) => (
            <p key={ratingType}>
              <RatingGroupItemCriterion>
                {t(`ratingTitle.${ratingType}`)}
              </RatingGroupItemCriterion>
              <UiLegacy.Rating value={rating} />
              <b>{format.number(rating, ratingFormatOptions)}</b> / 5
            </p>
          ))}
        </li>
      ))}
    </RatingGroupList>
  );
};

export { RatingGroups };
